"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20012ToJSON = exports.InlineResponse20012FromJSONTyped = exports.InlineResponse20012FromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InlineResponse20012FromJSON(json) {
    return InlineResponse20012FromJSONTyped(json, false);
}
exports.InlineResponse20012FromJSON = InlineResponse20012FromJSON;
function InlineResponse20012FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'summary': !(0, runtime_1.exists)(json, 'summary') ? undefined : (0, _1.InlineResponse20012SummaryFromJSON)(json['summary']),
        'games': !(0, runtime_1.exists)(json, 'games') ? undefined : json['games'],
        'timestamp': !(0, runtime_1.exists)(json, 'timestamp') ? undefined : json['timestamp'],
    };
}
exports.InlineResponse20012FromJSONTyped = InlineResponse20012FromJSONTyped;
function InlineResponse20012ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'summary': (0, _1.InlineResponse20012SummaryToJSON)(value.summary),
        'games': value.games,
        'timestamp': value.timestamp,
    };
}
exports.InlineResponse20012ToJSON = InlineResponse20012ToJSON;
